export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export interface SortingItem {
  key: string;
  direction: SortDirection;
}
